import LaunchApp from './index'
import { settings } from './settings'

const { appSettings, platformSettings, appData = {} } = settings

const app = LaunchApp(appSettings, platformSettings, appData)
const canvas = app.stage.getCanvas()
document.body.appendChild(canvas)
